import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';

import { initPostHog } from './initPostHog';

export function PostHogAppProvider({ children }: { children: React.ReactNode }) {
  // Init during render so posthog.init() runs before child useEffects (e.g. AnalyticsTracker).
  if (typeof window !== 'undefined') {
    initPostHog();
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
